import { render, staticRenderFns } from "./enterpriseOrderList.vue?vue&type=template&id=b5a567d2&scoped=true&"
import script from "./enterpriseOrderList.vue?vue&type=script&lang=js&"
export * from "./enterpriseOrderList.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseOrderList.vue?vue&type=style&index=0&id=b5a567d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a567d2",
  null
  
)

export default component.exports